import { z } from "zod";

const AllowedTypes = z.enum([
    "rate",
    "availability",
    "closed_to_arrival",
    "closed_to_departure",
    "max_stay",
    "min_stay_arrival",
    "min_stay_through",
    "stop_sell",
]);

const UpdateRestrictionSchema = z.object({
    type: AllowedTypes,
    value: z.string().regex(/^\d+$/, "Value must be a number"),
    date_ranges: z.array(z.object({
        date_from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
        date_to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)")
    })),
    rate_plan_id: z.string(),
}).refine((data) => {
    if (["closed_to_arrival", "closed_to_departure", "stop_sell"].includes(data.type)) {
        return data.value === "0" || data.value === "1";
    }
    if (["max_stay", "min_stay_arrival", "min_stay_through"].includes(data.type)) {
        return Number(data.value) >= 0;
    }
    return false;
}, {
    message: 'Invalid value for the selected type',
    path: ["value"],
});

export type UpdateRestrictionSchemaPayload = z.infer<typeof UpdateRestrictionSchema>;
export type AllowedTypeValues = z.infer<typeof AllowedTypes>;

export default UpdateRestrictionSchema;